import React from "react";
import { useApi } from "../../utils/api";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Loading from "../Layout/Loading";

const CoachingConnectedAccountReturn = () => {
  const { getAccount } = useApi();
  const { accountId } = useParams();
  useEffect(() => {
    const checkAccount = async () => {
      const account = await getAccount(accountId);
      if (!account) {
        setError(
          "Failed to get account. Please try again. Error: " +
            account.statusText
        );
      }
      if (account.details_submitted) {
        window.location.href = "/coaching/complete";
      } else {
        window.location.href = "/coaching/create-account-link";
      }
    };
    checkAccount();
  }, [accountId]);
  return <Loading style={{ m: 4 }} />;
};

export default CoachingConnectedAccountReturn;
